import script from './script'

const workerInformationScript = () => {
    return { script }
}
export default workerInformationScript